export const redirectToHome = () => {
    window.location.assign("/orders")
}